import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function Badge() {
    return (
        <>
            <Container fluid>
                <Col>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>برچسب ها</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/badge'>برچسب ها</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </Col>

                <div className='space-20' />

                <Row>
                    <Col sm={12} className='mb-4'>
                        <Card>
                            <div className='card-title bg-transparent p-3'>
                                انواع برچسب معمولی و بدون پس زمینه همراه با تیتر
                            </div>

                            <Card.Body>
                                <Row>
                                    <Col md={12} xl={6} className='mb-5'>
                                        <h1>
                                            یک نمونه تیتر
                                            <span className='badge bg-primary ml-2'>
                                                برچسب
                                            </span>
                                        </h1>
                                        <h2>
                                            یک نمونه تیتر
                                            <span className='badge bg-secondary ml-2'>
                                                برچسب
                                            </span>
                                        </h2>
                                        <h3>
                                            یک نمونه تیتر
                                            <span className='badge bg-danger ml-2'>
                                                برچسب
                                            </span>
                                        </h3>
                                        <h4>
                                            یک نمونه تیتر
                                            <span className='badge bg-success ml-2'>
                                                برچسب
                                            </span>
                                        </h4>
                                        <h5>
                                            یک نمونه تیتر
                                            <span className='badge bg-warning ml-2'>
                                                برچسب
                                            </span>
                                        </h5>
                                        <h6>
                                            یک نمونه تیتر
                                            <span className='badge bg-dark ml-2'>
                                                برچسب
                                            </span>
                                        </h6>
                                    </Col>

                                    <Col md={12} xl={6}>
                                        <span className='mr-2 mb-2 badge bg-primary'>
                                            اولیه
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-secondary'>
                                            ثانویه
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-success'>
                                            موفقیت آمیز
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-danger'>
                                            اخطار
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-warning text-dark'>
                                            هشدار
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-info text-dark'>
                                            اطلاعات
                                        </span>

                                        <span className='mr-2 mb-2 badge bg-dark'>
                                            تیره
                                        </span>

                                        <br />

                                        <span className='mr-2 mb-2 badge badge-outline-primary'>
                                            اولیه
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-secondary'>
                                            ثانویه
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-success'>
                                            موفقیت آمیز
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-danger'>
                                            اخطار
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-warning'>
                                            هشدار
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-info'>
                                            اطلاعات
                                        </span>

                                        <span className='mr-2 mb-2 badge badge-outline-dark'>
                                            تیره
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
